/* Black Friday slide-in. Live alleen tussen data-start en data-eind; op een previewthema altijd (ter beoordeling).
   Slaapgids: na 40% gelezen. Overige pagina's (ook productpagina's): na 6 s (Steinar 14 okt), desktop eerder bij
   verlaten van de pagina, mobiel eerder bij 40% scrollen. Na sluiten 7 dagen weg, na aanmelden nooit meer. ?bf_slidein=nu toont direct. */
(function () {
  var el = document.getElementById('bfs'); if (!el) return;
  var SL_DICHT = 'bfs_gesloten_tot', SL_KLAAR = 'bfs_aangemeld', DAGEN = 7;
  var nu = Date.now(), qs = location.search;
  var preview = window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main'
    && (/[?&]bf=1\b/.test(qs) || (function () { try { return sessionStorage.getItem('kameo_bf') === '1'; } catch (e) { return false; } })()); /* preview: alleen met ?bf=1, net als de sitebalk */
  var forceer = /[?&]bf_slidein=nu\b/.test(qs);
  var inVenster = nu >= Date.parse(el.dataset.start) && nu < Date.parse(el.dataset.eind);
  function lees(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function zet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  if (/[?&]utm_(source=klaviyo|medium=email)\b/.test(qs)) zet(SL_KLAAR, '1'); /* komt uit een mail: al abonnee */
  if (!forceer) {
    if (!(inVenster || preview)) return;
    if (lees(SL_KLAAR) || nu < +(lees(SL_DICHT) || 0)) return;
  }
  /* voorrang op de Matrascheck-slide-in */
  document.documentElement.classList.add('bfs-actief');

  var plek = el.dataset.plek, getoond = false;
  function dl(ev, x) { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: ev, bf_slidein_plek: plek }, x || {})); }
  function toon(bron) {
    if (getoond) return;
    var cb = document.getElementById('CybotCookiebotDialog'), zichtbaar = cb && cb.getClientRects().length > 0 && getComputedStyle(cb).visibility !== 'hidden';
    if ((window.Cookiebot && Cookiebot.hasResponse === false) || zichtbaar) { setTimeout(function () { toon(bron); }, 1000); return; }
    getoond = true;
    el.hidden = false;
    vrijmaken(); setInterval(vrijmaken, 800);
    requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('is-open'); }); });
    dl('bf_slidein_view', { bf_slidein_trigger: bron });
  }
  function sluit() {
    el.classList.add('is-dicht'); el.classList.remove('is-groot');
    zet(SL_DICHT, String(Date.now() + DAGEN * 864e5));
    document.documentElement.classList.remove('bfs-actief');
    dl('bf_slidein_sluit');
  }

  /* Niet over vaste elementen onderin (chatbalk, sticky koopbalk, paginanav): meet wat er horizontaal
     overlapt en schuif de slide-in daarboven. Het onderblad (is-groot) gaat er bewust overheen. */
  var BASIS = null;
  function vrijmaken() {
    if (el.classList.contains('is-groot')) { el.style.bottom = ''; return; }
    /* basis één keer meten; niet elke ronde terugzetten, anders zakt hij door de bottom-transitie steeds even achter de chat */
    if (BASIS === null) { el.style.bottom = ''; BASIS = parseFloat(getComputedStyle(el).bottom) || 0; }
    var mijn = el.getBoundingClientRect(), H = innerHeight, nodig = BASIS;
    document.querySelectorAll('#kameo-teaser, #paginanav, [class*="sticky-atc"], [class*="sticky-cta"], [id*="sticky"], #chatty-launcher, [class*="chat-bubble"]').forEach(function (b) {
      if (b === el || el.contains(b)) return;
      var s = getComputedStyle(b); if (s.position !== 'fixed' || s.display === 'none' || s.visibility === 'hidden' || +s.opacity === 0) return;
      var r = b.getBoundingClientRect(); if (r.width < 10 || r.height < 10 || r.top < H * 0.45 || r.top >= H) return;
      if (r.right <= mijn.left || r.left >= mijn.right) return;   /* niet in dezelfde kolom: geen probleem */
      nodig = Math.max(nodig, Math.ceil(H - r.top + 12));
    });
    if (el.style.bottom !== nodig + 'px') el.style.bottom = nodig + 'px';
  }

  /* triggers */
  var mobiel = matchMedia('(max-width:749.98px)').matches;
  var body = document.querySelector('[data-artikel-body]') || document.body;
  function gelezen() { var r = body.getBoundingClientRect(); return (innerHeight - r.top) / Math.max(1, r.height); }
  function scrol() { if (gelezen() >= 0.4) { toon('scroll'); removeEventListener('scroll', scrol); } }
  if (forceer) setTimeout(function () { toon('forceer'); }, 600);
  else if (plek === 'slaapgids') addEventListener('scroll', scrol, { passive: true });
  else if (mobiel) { addEventListener('scroll', scrol, { passive: true }); setTimeout(function () { toon('tijd'); }, 6000); }
  else {
    document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY <= 4) toon('verlaten'); });
    setTimeout(function () { toon('tijd'); }, 6000);
  }

  el.querySelectorAll('[data-bfs-sluit]').forEach(function (b) { b.addEventListener('click', function (e) { e.stopPropagation(); sluit(); }); });
  el.querySelector('[data-bfs-groot]').addEventListener('click', function () { el.classList.add('is-groot'); this.setAttribute('aria-expanded', 'true'); dl('bf_slidein_open'); });
  el.addEventListener('click', function (e) { if (el.classList.contains('is-groot') && e.target === el) sluit(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && el.classList.contains('is-open')) sluit(); });

  /* herkomst voor attributie: cart-attributen van ga-capture (gclid, landings-URL, referrer), max 1,5 s; faalt stil */
  function herkomst() {
    var leeg = new Promise(function (r) { setTimeout(function () { r({}); }, 1500); });
    var cart = fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
      .then(function (c) { return (c && c.attributes) || {}; }).catch(function () { return {}; });
    return Promise.race([cart, leeg]).then(function (a) {
      var p = { bf_pagina: location.pathname, bf_aangemeld_ts: new Date().toISOString() };
      var land = a.kameo_landing_url || location.href;
      p.bf_landing_url = String(land).split('#')[0].slice(0, 500);
      if (a.kameo_referrer) p.bf_referrer = String(a.kameo_referrer).slice(0, 300);
      [land, location.href].forEach(function (url) {
        try {
          var q = new URL(url).searchParams;
          ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'gbraid', 'wbraid', 'gad_campaignid', 'fbclid'].forEach(function (k) {
            var v = q.get(k); if (v && !p['bf_' + k]) p['bf_' + k] = v.slice(0, 200);
          });
        } catch (e) {}
      });
      if (a.kameo_gclid) p.bf_gclid = String(a.kameo_gclid).slice(0, 200);
      return p;
    }).catch(function () { return {}; });
  }

  /* aanmelden: Klaviyo client-subscriptions, lijst is verplicht */
  var form = el.querySelector('[data-bfs-form]'), veld = form.querySelector('input'), fout = el.querySelector('[data-bfs-fout]'), knop = form.querySelector('button');
  function toonFout(t) { fout.textContent = t; fout.hidden = !t; veld.setAttribute('aria-invalid', t ? 'true' : 'false'); }
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var email = veld.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { toonFout('Vul een geldig e-mailadres in.'); veld.focus(); return; }
    toonFout(''); knop.disabled = true;
    herkomst().then(function (h) {
    var props = { bf_lijst: true, bf_bron: plek, bf_aangemeld_op: new Date().toISOString().slice(0, 10) };
    for (var k in h) props[k] = h[k];
    var body = { data: { type: 'subscription', attributes: {
      custom_source: 'Black Friday slide-in',
      profile: { data: { type: 'profile', attributes: {
        email: email,
        properties: props,
        subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
      } } }
    }, relationships: { list: { data: { type: 'list', id: el.dataset.lijst } } } } };
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(el.dataset.company), {
      method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2026-07-15' }, body: JSON.stringify(body)
    }).then(function (res) {
      if (!res.ok) throw new Error('Klaviyo ' + res.status);
      zet(SL_KLAAR, '1');
      el.querySelector('[data-bfs-stap="form"]').hidden = true;
      el.querySelector('[data-bfs-stap="klaar"]').hidden = false;
      dl('bf_slidein_aanmelding');
      setTimeout(function () { el.classList.add('is-dicht'); el.classList.remove('is-groot'); document.documentElement.classList.remove('bfs-actief'); }, 6000);
    }).catch(function (err) {
      console.warn('Black Friday slide-in: aanmelden mislukt', err);
      toonFout('Dat lukte niet. Probeer het zo nog een keer.');
      knop.disabled = false;
    });
    });
  });
})();
